var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTileLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.311 2.514C2.603 3.696 1.73 6.619 2.882 9l-1.545.153C-.206 5.965.97 2.737 3.334 1.103c2.24-1.551 5.438-1.619 8.264.784 2.756-2.33 5.889-2.25 8.11-.746 2.343 1.588 3.588 4.73 2.199 7.861L19.997 9c1.023-2.307.463-5.276-1.252-6.437-1.67-1.133-4.2-1.243-6.541 1.097l-.607.607-.607-.607c-2.423-2.422-5.01-2.3-6.68-1.146zM11.6 17.645l8.116-8.117L21 10.536l-9.4 9.536L2 10.536l1.578-.913 8.022 8.022z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.646 4.117l3.28 4.753H24v1.717h-6.974l-2.487-3.603-4.472 5.544-2.861-3.59-1.385 1.65H0V8.87h5.02l2.22-2.642 2.835 3.556 4.57-5.667z",
    fill: "currentColor"
  })));
}
export default SvgTileLogo;